const regionNames = [
  'CIF',
  'docket_number',
  'plant',
  'arriving_date',
  'recipe',
  'delivered',
  'manufacture_time',
  'concrete_id',
  'compound',
  'relation_wc',
  'admixtures_id',
  'admixtures_quantity',
  'admixtures_extra',
  'delivery_company',
  'truck',
  'driver',
  'delivery_company_cif',
];

export default regionNames;
